import laptop from "./laptop.png"
import peripheral from './peripheral.png'
import techhelp from './techhelp.png'

export const WELCOME_SCREEN =
[
  {
    id: 0,
    img: laptop,
    link: "/laptops",
    caption: "Great Laptops Great Value",
    buttonText: "Find a Laptop",
    color: "success",
    alt: "I"
  },
  {
    id: 1,
    img: peripheral,
    link: "/",
    caption: "Powerful Peripherals",
    buttonText: "Coming soon",
    color: "primary",
    alt: "II"
  },
  {
    id: 2,
    img: techhelp,
    link: "/techsupport",
    caption: "Need Help?",
    buttonText: "Get Tech Support",
    color: "danger",
    alt: "III"
  }
]